<template>
    <div class="m-tc-main">
      <div class="m-tc-ar-button">
            <div class="m-tc-ar-button-icon">
                <SVGAR/>
            </div>
            <div class="m-tc-ar-button-text"
                 @click="switchToARMode()">
                Дополненная реальность
            </div>
        </div>
    </div>
    <MobileLoader :is-visible="storeUI.isMobileLoader"/>
</template>

<script>
import SVGAR from '@/UI/SVG/SVGAR.vue';
import { $ } from '@/Engine/state';
import { parseConfigStringToJSON, parseToolChestStringToJSON } from '@/libs/parseQueryConfig';
import { casesLib } from '@/Constants/casesLib';
import { storeConfigurationUpdate } from '@/Engine/app';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { useStoreUI } from '@/Store/storeUI';
import MobileLoader from '@/UI/Mobile/MobileLoader.vue';

export default {
    name: 'TheMobile',
    components: { MobileLoader, SVGAR },
    setup() {
      const storeCaseConfiguration = useStoreCaseConfiguration();
      const storeProjectStructure = useStoreProjectStructure();
      const storeUI = useStoreUI();

      return {
        storeCaseConfiguration,
        storeProjectStructure,
        storeUI,
      };
    },
    mounted: async function() {
      await this.parseQueryConfig();
      $.initConfigurator = true;
      await storeConfigurationUpdate(this.storeCaseConfiguration.$state);

    },
    methods: {
      async parseQueryConfig() {
        const dataInCaseItems = this.$route.query?.config;
        const dataInToolChest = this.$route.query?.toolChest;
        console.log(dataInCaseItems);
        console.log(dataInToolChest);
        if (!dataInCaseItems && !dataInToolChest) {
          return;
        }

        let dataOutCaseItems = parseConfigStringToJSON(dataInCaseItems);
        let dataOutToolChest = parseToolChestStringToJSON(dataInToolChest);
        const actualToolChest = casesLib.find(x => x.id === dataOutToolChest.blenderName);
        this.storeCaseConfiguration.$patch({
          caseItems: dataOutCaseItems,
          blenderName: dataOutToolChest.blenderName,
          selectedCaseModel: actualToolChest?.key,
          colorFrame: dataOutToolChest.colorFrame,
          colorFace: dataOutToolChest.colorFace,
          isCloseDoors: dataOutToolChest.isCloseDoors,
          drawerSeparators: dataOutToolChest.drawerSeparators,
          expandedDrawersPrototypeId: dataOutToolChest.expandedDrawersPrototypeId,
        });
        console.log('patched by URL config', this.storeCaseConfiguration.$state);
      },
        switchToARMode() {
          $.ARButton.click();
            // this.$router.push({ path: '/mobile/ar', query: this.$route.query });
        },
    },
};
</script>

<style scoped lang="scss">
.m-tc-main {
    width: 100%;
    height: 100%;
    position: absolute;
    box-sizing: border-box;
    display: flex;
    padding: 30px;
    justify-content: center;
    align-items: flex-end;
    font-family: Montserrat, sans-serif;
    pointer-events: none;
}

.m-tc-ar-button {
    display: grid;
    grid-template-columns: 22px 1fr;
    grid-column-gap: 15px;
    justify-content: center;
    align-items: center;
    height: 40px;
    padding: 0 20px;
    z-index: 1000;
    position: relative;
    color: white;
    background-color: #00458D;
    pointer-events: all;
    cursor: pointer;
    overflow: hidden;

}

.m-tc-ar-button:active {
    color: #ffffff;
    background-color: #F58214;
    box-shadow:none;
}

.m-tc-ar-button-text {
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
}

.m-tc-ar-button-icon {
    display: grid;
    width: 22px;
    height: 22px;
    align-items: center;
    justify-content: center;
}

</style>
